const Cross: React.FC<{
  className?: string;
  fill?: string;
}> = ({ className = '', fill = '#272D2A' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={className}
    >
      <path
        d="M30.7067 10.7065L21.4131 20.0001L30.7067 29.2937L29.2939 30.7065L20.0003 21.4128L10.7067 30.7065L9.29395 29.2937L18.5876 20.0001L9.29395 10.7065L10.7067 9.2937L20.0003 18.5873L29.2939 9.2937L30.7067 10.7065Z"
        fill={fill}
      />
    </svg>
  );
};

export default Cross;
